<template>
  <div class="fill-height">
    <reference-details-section
      v-if="!loading"
      :review="review"
      :reference="reference"
      :current-researcher="currentResearcher"
      :allow-edit="enableEditReferenceDetails"
      :tab-order="tabOrder"
      :disable-extraction-panel="disableModification"
      :allow-submit-for-consensus="allowSubmitForConsensus"
      @edit="onEditReferenceDetails"
      @download-full-text="onDownloadFullText"
      @delete-full-text="onDeleteFullText"
      @update-tags="onSetReferenceTags"
      @submit="$emit('save-for-consensus')"
      @update:hasUnsavedComment="
        $emit('update:hasUnsavedComment', $event)
      "
    />
    <reference-form-modal
      class="flex-grow-0"
      :reference="editReference"
      :focus-field="editReferenceField"
      @save="onSaveReference"
      @cancel="onCancelEditReference"
    />
  </div>
</template>

<script>
import ReferenceDetailsSection from '@/components/References/ReferenceDetailsSection';
import ReferenceFormModal from '@/components/ReferenceForm/ReferenceFormModal';
import { Review, Reference, Researcher } from '@/models';
import { mapActions } from 'vuex';

export default {
  name: 'ReferenceDetailsController',
  components: {
    ReferenceDetailsSection,
    ReferenceFormModal,
  },
  props: {
    review: {
      type: Review,
      default: null,
    },
    reference: {
      type: Reference,
      default: null,
    },
    currentResearcher: {
      type: Researcher,
      default: null,
    },
    showingPending: {
      type: Boolean,
      default: false,
    },
    enableEditReferenceDetails: {
      type: Boolean,
      default: false,
    },
    allowSubmitForConsensus: {
      type: Boolean,
      default: false,
    },
    disableModification: {
      type: Boolean,
      default: false,
    },
    tabOrder: {
      type: Array,
      default: undefined,
    },
  },
  emits: [
    'save-for-consensus',
    'update:hasUnsavedComment',
    'update:reference',
  ],
  data: () => ({
    editReference: null,
    editReferenceField: null,
  }),
  computed: {
    loading() {
      return (
        this.review === null ||
        this.reference === null ||
        this.currentResearcher === null
      );
    },
  },
  methods: {
    ...mapActions({
      updateReferenceFields: 'reference/updateReferenceFields',
      fetchFullTextDownloadUrl: 'fullTextPdf/fetchDownloadUrl',
      deleteFullTextPdf: 'fullTextPdf/delete',
      setReferenceTags: 'reference/setReferenceTags',
    }),
    async onDownloadFullText() {
      const url = await this.fetchFullTextDownloadUrl({
        referenceId: this.reference.id,
        forDownload: true,
      });
      const a = document.createElement('a');
      a.href = url;
      a.click();
    },
    onDeleteFullText() {
      this.deleteFullTextPdf(this.reference.id);
    },
    onSetReferenceTags(tags) {
      this.setReferenceTags({
        reference: this.reference,
        tags: tags,
      });
    },
    onEditReferenceDetails(field) {
      this.editReference = this.reference;
      this.editReferenceField = field;
    },
    onSaveReference(reference) {
      const previousReference = this.reference;
      this.$emit('update:reference', reference);
      try {
        this.updateReferenceFields(reference);
        this.onCancelEditReference();
      } catch {
        this.$emit('update:reference', previousReference);
      }
    },
    onCancelEditReference() {
      this.editReference = null;
      this.editReferenceField = null;
    },
  },
};
</script>
